import { yupResolver } from "@hookform/resolvers/yup"
import { useState } from "react"
import { useForm } from "react-hook-form"
import toast, { Toaster } from "react-hot-toast"
import { useNavigate } from 'react-router-dom'
import * as yup from 'yup'
import { translations } from "../../configs/translations"
import PasswordRecoveryService from "../../services/PasswordRecoveryService"
import { useStore } from "../../store/store"
import './PasswordRecovery.css'
import { PasswordRecoveryWindowCode } from "./recoveryWindows/CodePasswordRecoveryWindow"
import { PasswordRecoveryWindowEmail } from "./recoveryWindows/EmailPasswordRecoveryWindow"
import { PasswordRecoveryWindowPassword } from "./recoveryWindows/PasswordRecoveryWindow"

export const PasswordRecovery = () => {

    const language = useStore(state => state.language);
    const t = translations[language];

    const emailSchema = yup.object({
        email: yup
            .string()
            .required(t.email_required)
    });
    
    const codeSchema = yup.object({
        code: yup
            .number()
            .typeError(t.code_must_be_number)
            .required(t.code_required)
    });

    const passwordSchema = yup.object({
        password: yup
            .string()
            .required(t.password_required)
            .min(8, t.password_must_be_at_least_8_characters)
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,}$/,
                t.password_pattern
            )
    });  

    const {
        register: registerField1,
        handleSubmit: handleSubmit1,
        formState: { errors: errors1 },
        watch: watch1
    } = useForm({
        resolver: yupResolver(emailSchema),
        mode: 'onChange'
    });

    const email = watch1('email');

    const {
        register: registerField2,
        handleSubmit: handleSubmit2,
        formState: { errors: errors2 },
        watch: watch2
    } = useForm({
        resolver: yupResolver(codeSchema),
        mode: 'onChange'
    });
    const code = watch2('code');

    const {
        register: registerField3,
        handleSubmit: handleSubmit3,
        formState: { errors: errors3 },
        watch: watch3
    } = useForm({
        resolver: yupResolver(passwordSchema),
        mode: 'onChange'
    });
    const password = watch3('password');

    const [step, setStep] = useState(1);
    const [time, setTime] = useState(120);
    let countDown: NodeJS.Timeout;

    const onEmailSubmit = async () => {
        await PasswordRecoveryService.sendEmail(email)
            .then(() => {
                setStep(2);
                if (!countDown) {
                    let k = 120;
                    countDown = setInterval(() => {
                        setTime(k--);
                        if (k <= 0) {
                            clearInterval(countDown);
                            setTime(0);
                        }
                    }, 1000);
                }
            })
            .catch((error) => {
                toast.error(
                    error && error.response && error.response.data && t[error.response.data as keyof typeof t] 
                        ? t[error.response.data as keyof typeof t] 
                        : t.error_unknown,
                    { className: 'notification-error' }
                );
            });
    }

    const onCodeSubmit = async () => {
        clearInterval(countDown);
        await PasswordRecoveryService.validateCode(email, code)
            .then(() => {
                setStep(3);
            })
            .catch((error) => {
                toast.error(
                    error && error.response && error.response.data && t[error.response.data as keyof typeof t] 
                        ? t[error.response.data as keyof typeof t] 
                        : t.error_unknown,
                    { className: 'notification-error' }
                );
            });
    }

    const navigate = useNavigate();
    const onPasswordSubmit = async () => {
        await PasswordRecoveryService.updatePassword(email, code, password)
            .then(() => {
                navigate('/login');
            })
            .catch((error) => {
                toast.error(
                    error && error.response && error.response.data && t[error.response.data as keyof typeof t] 
                        ? t[error.response.data as keyof typeof t] 
                        : t.error_unknown,
                    { className: 'notification-error' }
                );
            });
    }

    return (
        <div className="container">
                {
                    step === 1 && (
                        <PasswordRecoveryWindowEmail 
                            email={email} 
                            errors={errors1}
                            registerField={registerField1}
                            onSubmit={onEmailSubmit}
                        />
                    )
                    
                }
                {
                    step === 2 && (
                        <PasswordRecoveryWindowCode 
                            code={code} 
                            errors={errors2}
                            registerField={registerField2}
                            onSubmit={onCodeSubmit}
                            onEmailSubmit={onEmailSubmit}
                            onBack={() => setStep(1)}
                            time={time}
                        />
                    )
                }
                {
                    step === 3 && (
                        <PasswordRecoveryWindowPassword 
                            password={password} 
                            errors={errors3}
                            registerField={registerField3}
                            onSubmit={onPasswordSubmit}
                            onBack={() => setStep(2)}
                        />
                    )
                }

                <Toaster 
                    position="bottom-center"
                    toastOptions={{
                        duration: 2000,
                    }}
                />
        </div>
    );
}